module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-4.68cf81a3.svg";